module.exports = __webpack_public_path__ + "media/country_flags/gl-a77e5c86.png";